import { StyledSelectItem } from './SelectItem.styled';

const SelectItem = ({ onClick, slot, isSelected=false }) => {
  return (
    <StyledSelectItem onClick={() => onClick ? onClick() : false} $selected={isSelected}>
      <div className='select-item-content'>
        <div className='select-item-img-wrapper'>
          <img className='select-item-img' src={slot.image || '/assets/inv_object.svg'} />
        </div>
        <div className='select-item-type'>
          <div className='select-item-type-name'>select</div>
          <div className='select-item-number'>
            <span>[</span>
            <span className='number'>{slot.options.length}</span>
            <span>]</span>
          </div>
        </div>
        <div className='select-item-action-icon'>
          <img src={isSelected ? '/assets/arrows_selected.svg' : '/assets/arrows.svg'} />
        </div>
        <span className='flare'/>
        <div className='select-item-label-holder'>
          <div className='select-item-label'>
            <div className='corner-left'/>
            <div className='label'>
              {slot.type}
            </div>
            <div className='corner-right'/>
          </div>
        </div>
      </div>
    </StyledSelectItem>
  );
};

export default SelectItem;
